import { render, staticRenderFns } from "./DeadlineEntryUpdateDialog.vue?vue&type=template&id=2530eafc"
import script from "./DeadlineEntryUpdateDialog.vue?vue&type=script&lang=js"
export * from "./DeadlineEntryUpdateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports